import { Box, Button, Divider } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTime } from 'luxon';
import type { ReactElement } from 'react';

interface Props {
  filterValues: any[];
  onFilterChange: (values: any[]) => void;
  onFilterClear: () => void;
}

export const DateTimeColumnFilter = ({
  filterValues,
  onFilterChange,
  onFilterClear,
}: Props): ReactElement => {
  const parseInputValueToDate = (value: string | Date | DateTime | null): DateTime | null => {
    if (!value || value === '') return null;

    if (DateTime.isDateTime(value)) {
      return value.isValid ? value : null;
    }

    if (value instanceof Date) {
      const dt = DateTime.fromJSDate(value);
      return dt.isValid ? dt : null;
    }

    if (typeof value === 'string') {
      const dt = DateTime.fromISO(value);
      return dt.isValid ? dt : null;
    }

    return null;
  };

  return (
    <Box display='flex' flexDirection='column' alignItems='center' flexWrap='nowrap'>
      <Box display='flex' flexDirection='column' gap='1rem' width='100%'>
        <DatePicker
          label='From Date'
          value={parseInputValueToDate(filterValues[0])}
          onChange={(newValue) =>
            onFilterChange([
              newValue?.toJSDate(),
              parseInputValueToDate(filterValues[1])?.toJSDate(),
            ])
          }
          slotProps={{
            textField: {
              size: 'small',
              fullWidth: true,
            },
            actionBar: {
              actions: ['today', 'clear'],
            },
          }}
        />
        <DatePicker
          label='To Date'
          value={parseInputValueToDate(filterValues[1])}
          onChange={(newValue) =>
            onFilterChange([
              parseInputValueToDate(filterValues[0])?.toJSDate(),
              newValue?.toJSDate(),
            ])
          }
          slotProps={{
            textField: {
              size: 'small',
              fullWidth: true,
            },
            actionBar: {
              actions: ['today', 'clear'],
            },
          }}
        />
      </Box>
      <Divider sx={{ width: '100%', marginY: 2 }} />
      <Box display='flex' width='100%' justifyContent='flex-end'>
        <Button onClick={onFilterClear} size='small'>
          Clear
        </Button>
      </Box>
    </Box>
  );
};
